import { AdminReconciliationScreen } from '@features/admin/ui/AdminReconciliationScreen'

export function ReconciliacaoPage() {
  return <AdminReconciliationScreen />
}
